<template lang="pug">
div(:class='{ "chat-paused-flag" : takeover, "chat-duplicate-agent" : duplicateAgent }')
  h6(style='margin-top: -2px; margin-left: -1px' v-if='takeover')
    b-badge(variant='danger') Agent Takeover Active
  div.row(v-for='(msg, index) in msgs', :id='msg.chatID', :key='index')
    div.col-md-12
      div.col-md-6(v-if='msg.fromUser')
        div.row
          div.col-md-2
            img.img-avatar(:src='profPic', style='height: 50px; width: 50px')
          div.col-md-10
            p.chat-left.text-left
              span(v-if='msg.message.imageUrl')
                img(:src='msg.message.imageUrl' :alt='msg.message.message', style='max-width: 100%')
              span(v-else)
                | {{msg.message}}
              br
              span(v-if='msg.translatedText')
                i.translatedText {{msg.translatedText}}
                br
              small.text-muted
                | sent {{msg.timestamp | moment('from', 'now')}} from
                span(v-if='msg.fromUser')
                  span(v-if='msg.platform.bot')  {{msg.platform.bot | parseBot}}
                  |  {{msg.platform.source | parsePlatform}}
                div.text-muted.float-right
                  //- button.btn.btn-success(v-if="msg.sentiment >= 0")
                  //-   span.fa.fa-thumbs-o-up
                  //-     |  {{msg.sentiment}}
                  //- button.btn.btn-secondary(v-else-if="msg.sentiment == '-'")
                  //-   span
                  //-     |  {{msg.sentiment}}
                  //- button.btn.btn-danger(v-else="msg.sentiment < 0")
                  //-   span.fa.fa-thumbs-o-down
                      |  {{msg.sentiment}}
                  span.individualSuccessSentiment.text-light(v-if="msg.sentimentValue >= 0")
                    | {{msg.sentiment}} &nbsp;
                    span.fa.fa-thumbs-o-up
                  span.individualDangerSentiment.text-light(v-else-if="msg.sentimentValue < 0")
                    | {{msg.sentiment}} &nbsp;
                    span.fa.fa-thumbs-o-down
                  b-button.btn-translate(variant="link" no-caret @click="translate(msg.message, index)")
                    span.fa.fa-globe.text-muted
      div(v-else-if='!msg.fromUser')
        div.col-md-6
        div.col-md-6.pull-right(v-if='msg.message')
          div.row(v-if='(msg.message[0].speech && msg.message[0].speech != "") || (msg.message[0].text && msg.message[0].text.text[0]) || (msg.message[0].payload) || typeof msg.message === "string" || (msg.message[0].title)  || (msg.message[0].address) || (msg.message[0].elements) ')
            div.col-md-10
              p.chat-right.text-right
                span(v-if='typeof msg.message != "string" && msg.message[0].speech')
                  | {{msg.message[0].speech}}
                span(v-else-if='typeof msg.message != "string" && msg.message[0].text')
                  | {{msg.message[0].text.text[0]}}
                //- section for generating quick reply in interaction
                span(v-else-if='typeof msg.message != "string" && msg.message[0].quickReplies')
                  | {{msg.message[0].title}}
                //- section for generating carousel in interaction
                section(class='VueCarousel' style='position:static' v-else-if='typeof msg.message != "string" && msg.message[0].address')
                  div(class='VueCarousel-wrapper')
                    //- 1 slide per page for carousel
                    Carousel(:per-page='1', :paginationPadding='5', :mouseDrag='true')
                      //- for each message(slide) received, create a respective slide
                      //- TODO: originally need to assign ID but not meaningful id for now, need to put ID for solving the warning
                      slide(tabindex='-1' style='margin-bottom: 0px', v-for='message in msg.message', :key='message.id' v-if='message.address')
                        div(class='carousel-generic-content')
                          img(class='carousel-generic-image', :src='message.picUrl' style="max-width: 100%; border-bottom: thin solid rgb(204, 204, 204);")
                          //- title and subtitle in carousel-cart class
                          div(class='carousel-cart' style='border-bottom: thin solid rgb(204, 204, 204);')
                            span(class='carousel-title')
                              | {{message.name}} <br>
                            span(class='carousel-subtitle')
                              | Tel: {{message.tel}}<br>Fax: {{message.fax}}<br>Contact Person: {{message.contactPerson}}<br>E-mail: {{message.email}}
                          //- for each button, create a button
                          //- div(class='carousel-generic-button' style='border-bottom: thin solid rgb(204, 204, 204), height: 20px' v-for='button in message.buttons')
                            | {{button.title}} <br>
                  //- terry's suggestion
                  //- div(style='text-align: center' class='quick-replies', v-if='msg.chatID == msgs[msgs.length - 1].chatID')
                    //- generate one for each quick reply
                    div.pull-right(class='quick-reply' v-for='quickReply in msg.message[0].quickReplies')
                      | {{quickReply}}
                  //- section for generating carousel in interaction
                section(class='VueCarousel' style='position:static' v-else-if='typeof msg.message != "string" && msg.message[0].title')
                  div(class='VueCarousel-wrapper')
                    //- 1 slide per page for carousel
                    Carousel(:per-page='1', :paginationPadding='5', :mouseDrag='true')
                      //- for each message(slide) received, create a respective slide
                      //- TODO: originally need to assign ID but not meaningful id for now, need to put ID for solving the warning
                      slide(tabindex='-1' style='margin-bottom: 0px', v-for='message in msg.message', :key='message.id')
                        div(class='carousel-generic-content')
                          img(class='carousel-generic-image', :src='message.image_url')
                          //- title and subtitle in carousel-cart class
                          div(class='carousel-cart' style='border-bottom: thin solid rgb(204, 204, 204);')
                            span(class='carousel-title')
                              | {{message.title}} <br>
                            span(class='carousel-subtitle')
                              | {{message.subtitle}} <br>
                          //- for each button, create a button
                          div(class='carousel-generic-button' style='border-bottom: thin solid rgb(204, 204, 204), height: 20px' v-for='button in message.buttons')
                            | {{button.title}} <br>
                //- section for generating list template in interaction
                section(class="carousel message" v-else-if='typeof msg.message != "string" && msg.message[0].elements')
                  div(class="carousel-div" v-for='element in msg.message[0].elements')
                    div(class="carousel-cart")
                      span(class="carousel-title")
                        | {{element.title}}
                      br
                      span(class="carousel-subtitle")
                        | {{element.subtitle}}
                      br
                      br
                      span(class="carousel-list-button")
                        | {{element.buttons[0].title}}
                  div(class="carousel-div-last")
                    div(class="carousel-cart")
                      span(class="carousel-list-button")
                        | {{msg.message[0].buttons[0].title}}
                span(v-else)
                  | {{msg.message}}
                br
                small.text-muted
                  | sent {{msg.timestamp | moment('from', 'now')}} from
                  span(v-if='msg.dashboard')
                    i  Enchatment Engine
                  span(v-else)
                    i  Bot
                  span(v-if='msg.platform')  via
                    span(v-if='msg.platform.bot')  {{msg.platform.bot | parseBot}}
                    |  {{msg.platform.source | parsePlatform}}
            div.col-md-2
              img.img-avatar(:src='botPic')
    //- if the chatID of the message is same with the last messages chatID, then show quick reply
    div.col.md-12(v-if='!msg.fromUser && (typeof msg.message != "string" && msg.message[0].quickReplies)')
      div.col-md-6
        div.row
          div.col-md-2
          div.col-md-10
            div.row(class='quick-replies')
              div(v-for='quickReply in msg.message[0].quickReplies')
                div(class='quick-reply-highlighted' v-if='msgs[index+1] && msgs[index+1].fromUser && quickReply === msgs[index+1].message && quickReply.content_type')
                  | {{quickReply.content_type}}
                div(class='quick-reply-highlighted' v-else-if='msgs[index+1] && msgs[index+1].fromUser && quickReply === msgs[index+1].message')
                  | {{quickReply}}
                div(class='quick-reply-dimmed' v-else-if='quickReply.content_type')
                  | {{quickReply.content_type}}
                div(class='quick-reply-dimmed' v-else)
                  | {{quickReply}}
    div.clearfix
  h6(style='margin-bottom: -2px; margin-left: -1px' v-if='takeover')
    b-badge(variant='danger') Agent Takeover Active
</template>
<script>
import { send, translateServer } from '@/api'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'app-chat',
  components: {
    Carousel,
    Slide,
  },
  props: {
    loading: true,
    profPic: {
      type: String,
      default: 'static/img/avatars/0.png',
    },
    takeover: false,
    duplicateAgent: false,
    botPic: {
      type: String,
      default: 'static/img/favicon.png',
    },
    msgs: {
      type: Array,
      default: () => [
      ],
    },
  },
  mounted: function() {
    // console.log(this.msgs)
  },
  methods: {
    sendMessage() {
      /* var content = {
        platform: 'webPopup',
        recipientID: this.pageID,
        message: this.msg.content
      } */
      var content
      send(content)
        .then(function (res) {
          res.error && alert(res.error)
        })
      this.$refs.popover.$emit('close')
    },
    translate(query, messageIndex) {
      var content = {
        query,
        target: 'en',
      }
      let that = this
      translateServer(content)
        .then(function (res) {
          that.msgs[messageIndex].translatedText = res.answer
          res.error && alert(res.error)
        })
    },
    onClose() {
      // Emitting 'close' on the popover will trigger it to hide for us
      this.$refs.popover.$emit('close')
    },
    userIDString (value) {
      return value ? value.toString() : ''
    },
  },
  filters: {
    parsePlatform(platform) {
      const platforms = {
        'sms': 'SMS',
        'fb': 'Facebook',
        'whatsapp': 'WhatsApp',
        'default': 'Website',
      }
      // return (platform == 'sms') ? 'SMS' : 'CI Bank Website'
      return platforms[platform] || platforms['default']
    },
    parseBot(bot) {
      const bots = {
        'insurbot': 'LiveLife',
        'cibank': 'CI Bank',
        'default': 'Chat Infinite',
      }
      // return (platform == 'sms') ? 'SMS' : 'CI Bank Website'
      return bots[bot] || bots['default']
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Chat.vue?e295b744